'use client';

import React from 'react';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

import AdvancedSearchLegacy from './AdvancedSearchLegacy';
import AdvancedSearchNext from '../advanced-search-next';

const AdvancedSearchAdapter = props => {
  const isBrowser = useIsBrowser();
  const postHogFlag = usePostHogFeatureFlag('advancedSearchPageNext');

  if (!isBrowser) {
    return <div />;
  }

  const useNextVersion = postHogFlag === 'test' || isNewConsumerApp;

  return useNextVersion ? (
    <AdvancedSearchNext {...props} />
  ) : (
    <AdvancedSearchLegacy {...props} />
  );
};

export default AdvancedSearchAdapter;
